module.exports = __webpack_public_path__ + "static/media/remove-icon.11283c85.svg";